import React from "react";

import { Box, Flex } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import { IrmaoTable } from "../../../pages/Criancas/ReferenciaFamiliar/Irmaos/Table";

export const Pendencias = ({ data, idCrianca }) => {
  const columns = [
    {
      Header: "Pendências",
      accessor: "descricaoTipoPendencia",
      Cell: (props) => {
        const pendencia = props?.value;

        return <span>{pendencia ? pendencia : ""}</span>;
      },
    },
    {
      Header: "Aba",
      accessor: "nomeAba",
      Cell: (props) => {
        const nomeAba = props?.value;

        return <span>{nomeAba ? nomeAba : ""}</span>;
      },
    },
  ];

  return data ? (
    <Box className="break-page">
      <Flex>
        <Group bgColor="#fff" title="PENDÊNCIAS" py="12px" mtDivider="5px">
          <Box mt="12px">
            <IrmaoTable
              mt={"0px"}
              columns={columns}
              data={data}
              entidade="pendencias"
              isPrint={true}
              disableHeaderOptions
              disableHeaderOptionsOpcoes
              disableHeaderOptionsPagination
            />
          </Box>
        </Group>
      </Flex>
    </Box>
  ) : (
    <Box className="break-page">
      <Flex>
        <Group
          bgColor="#fff"
          title="PENDÊNCIAS"
          mt="15px"
          py="12px"
          mtDivider="5px"
        />
      </Flex>
    </Box>
  );
};
